var BASE_URL = process.env.API_ROOT + "/v2"
var ADMIN_BASE_URL = process.env.ADMIN_API_ROOT + "/v1"

export default {
    AUTH_INAPP: BASE_URL + "/auth/${type}/access",
    FETCH_SHORT_URL: BASE_URL + "/link/short?key=",
    FETCH_HOSPITAL_INFOS: ADMIN_BASE_URL + "/hospital/${uuid}/promotion",
    FETCH_USER_VISIT_INFOS: BASE_URL + "/auth/${uuid}",
    SEND_EVENT_CODE: BASE_URL + "/web/bridge/event"
}


// WEBPACK FOOTER //
// ./src/Config.js